import { CalendarDays, MapPin } from 'lucide-react';
import { calendarOf, dateKey, formatTime, formatDayLong, startOfDay, addDays, sameDay } from '../../lib/calendar';

// Ajanda: seçili günden itibaren 30 günün etkinlikleri, günlere göre gruplu liste
export const AgendaView = ({ cursor, events, holidays, onEventClick, selectedId }) => {
  const days = Array.from({ length: 30 }, (_, i) => addDays(startOfDay(cursor), i));
  const groups = days
    .map((day) => {
      const start = day.getTime();
      const end = addDays(day, 1).getTime();
      const list = events
        .filter((e) => e.end.getTime() > start && e.start.getTime() < end)
        .sort((a, b) => Number(b.all_day) - Number(a.all_day) || a.start - b.start);
      return { day, list, holiday: holidays?.[dateKey(day)] };
    })
    .filter((g) => g.list.length > 0 || g.holiday);

  if (groups.length === 0) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center text-center p-10" data-testid="agenda-empty">
        <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center mb-3"><CalendarDays className="h-6 w-6 text-muted-foreground" /></div>
        <p className="text-sm text-muted-foreground">Önümüzdeki 30 günde etkinlik yok</p>
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0 overflow-y-auto scrollbar-thin" data-testid="agenda-view">
      <div className="max-w-3xl mx-auto px-4 py-4 space-y-5">
        {groups.map(({ day, list, holiday }) => (
          <section key={dateKey(day)}>
            <h3 className={`text-sm font-semibold mb-2 ${sameDay(day, new Date()) ? 'text-primary' : ''}`}>{formatDayLong(day)}</h3>
            <div className="space-y-2">
              {holiday && <div className="rounded-lg bg-secondary px-3 py-2 text-sm text-muted-foreground">{holiday}</div>}
              {list.map((e) => (
                <button
                  key={e.id}
                  onClick={() => onEventClick(e)}
                  className={`w-full text-left flex items-start gap-3 rounded-lg border-l-[3px] px-3 py-2.5 hover:shadow-md transition-shadow ${calendarOf(e.color).box} ${selectedId === e.id ? 'ring-2 ring-primary' : ''}`}
                  data-testid={`event-${e.id}`}
                >
                  <div className="w-28 shrink-0 text-xs pt-0.5 opacity-80">
                    {e.all_day ? 'Tüm gün' : `${formatTime(e.start)} – ${formatTime(e.end)}`}
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold truncate">{e.title}</div>
                    {e.location && <div className="flex items-center gap-1 text-xs opacity-80 mt-0.5"><MapPin className="h-3 w-3" />{e.location}</div>}
                  </div>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default AgendaView;
